var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', [_c('span', {
    staticClass: "decode"
  }, [_vm._v("hex")]), _vm._v(" " + _vm._s(_vm.text_hex))]), _c('p', [_c('span', {
    staticClass: "decode"
  }, [_vm._v("UTF-8")]), _vm._v(" " + _vm._s(_vm.text_utf8))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }